import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import i18n from './i18n'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
}));

function PrivacyPolicy() {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;
  const {t, i18n} = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <Grid container >
      <Card className={classes.root} variant="outlined" textAlign="center">
      <CardContent>
        <Typography component="h2"　variant="h4"　>
        {t('Privacy Policy')}
        </Typography>
        <Divider/>
        <Typography component="h2"　variant="h6"　>
        {t('About Authority')}
        </Typography>
        <Divider/>
        <Typography variant="body2" component="p">
        {t('Privacy Policy_1')}<br/>
        </Typography>
        <Typography component="h2"　variant="h6"　>
        {t('Camera')}
        </Typography>
        <Divider/>
        <Typography variant="body2" component="p">
        {t('Privacy Policy_2')}<br/>
        </Typography>
        <Typography component="h2"　variant="h6"　>
        {t('Storage')}
        </Typography>
        <Divider/>
        {t('Privacy Policy_3')}<br/>
        <Typography component="h2"　variant="h6"　>
        {t('About Advertising')}
        </Typography>
        <Divider/>
        <Typography variant="body2" component="p">
        {t('Privacy Policy_4')}<br/>
        </Typography>
        <Typography variant="body2" component="p">
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">{t('Privacy_Policy_5')}</a><br/>
        </Typography>
        <Typography component="h2"　variant="h6"　>
        {t('About Usage Analysis')}
        </Typography>
        <Divider/>
        <Typography variant="body2" component="p">
        {t('Privacy Policy_6')}<br/>
        </Typography>
        <Typography variant="body2" component="p">
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">{t('Privacy_Policy_7')}</a><br/>
        </Typography>
      </CardContent>
    </Card>
      </Grid>
    </div>
  )
}






export default PrivacyPolicy

